import { stableKey } from '../../../lib';

export const templateSelectionKeys = {
  all: ['templateSelection'] as const,

  mutations: {
    updateTheme: () => stableKey(['templateSelection', 'updateTheme']),
    createSite: () => stableKey(['templateSelection', 'createSite']),
    createSitelessMetasite: () => stableKey(['templateSelection', 'createSitelessMetasite']),
    installStoresApp: () => stableKey(['templateSelection', 'installStoresApp']),
    attachTemplate: () => stableKey(['templateSelection', 'attachTemplate']),
    setupProducts: () => stableKey(['templateSelection', 'setupProducts']),
    installApps: () => stableKey(['templateSelection', 'installApps']),
    resetStore: () => stableKey(['templateSelection', 'resetStore']),
  },
} as const;
